import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from './auth.service';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class AuthGuardService implements CanActivate {

    constructor(private authService: AuthService, private router: Router) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

        // Check if the user is authenticated by validating context parameters
        return this.authService.isAuthenticated().then((isAuthenticated: boolean) => {
            if (isAuthenticated == true) {
                // If authenticated, allow access to the route
                return true;
            } else {
                // If not authenticated, redirect to the not-found page
                this.router.navigate(['/unauthorized']);
                return false;
            }

        });
    }
}